import React, { useState, useEffect } from "react";
import { Table, AutoComplete, Input, Descriptions, Tag, Button, message, Popconfirm } from "antd";
import { Api_VariavelGlobal } from "../global";

const PedidosTodos = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [options, setOptions] = useState([]);
  const [produtosPorPedido, setProdutosPorPedido] = useState({});
  const [usuarios, setUsuarios] = useState({});
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  const formatarData = (dataISO) => {
    if (!dataISO) return "";
    const clean = dataISO.replace("T", " ").replace("Z", "").replace(".000", "");
    const [date, time] = clean.split(" ");
    const [ano, mes, dia] = date.split("-");
    return `${dia}/${mes}/${ano} ${time}`;
  };
  
    // Traduzir status
    const traduzirStatus = (valor) => {
      switch (parseInt(valor, 10)) {
        case 1:
          return { texto: "Recebido / Aguardando Pagamento", cor: "blue" };
        case 2:
          return { texto: "Sem Status", cor: "default" };
        case 3:
          return { texto: "Aguardando Confirmaão / Início Produção", cor: "orange" };
        case 4:
          return { texto: "Produão", cor: "processing" };
        case 5:
          return { texto: "Saiu para Entrega", cor: "purple" };
        case 6:
          return { texto: "Concluído", cor: "green" };
        case 7:
          return { texto: "Cancelado", cor: "red" };
        default:
          return { texto: "Desconhecido", cor: "default" };
      }
    };


  // Buscar usurios
  useEffect(() => {
    const fetchUsuarios = async () => {
      try {
        const response = await fetch(`${Api_VariavelGlobal}/api/users`);
        const users = await response.json();
        const mapUsuarios = {};
        users.forEach((user) => {
          mapUsuarios[user.ID_USUARIO] = user.LOGIN;
        });
        setUsuarios(mapUsuarios);
      } catch (error) {
        console.error("Erro ao buscar usuários:", error);
      }
    };
    fetchUsuarios();
  }, []);

  // Buscar pedidos + itens
  useEffect(() => {
    const fetchPedidos = async () => {
      try {
        const response = await fetch(`${Api_VariavelGlobal}/api/pedidos`);
        const pedidos = await response.json();

        const pedidosFormatados = pedidos.map((pedido) => {
          const enderecoCompleto = `${pedido.ENDERECO || ""}${
            pedido.NUMERO ? `, ${pedido.NUMERO}` : ""
          }${pedido.COMPLEMENTO ? `, ${pedido.COMPLEMENTO}` : ""}${
            pedido.CIDADE ? `, ${pedido.CIDADE}` : ""
          }${pedido.UF ? `/${pedido.UF}` : ""}${
            pedido.CEP ? `, CEP: ${pedido.CEP}` : ""
          }`;

          return {
            key: pedido.ID_PEDIDO,
            pedido: pedido.ID_PEDIDO,
            ID_USUARIO: pedido.ID_USUARIO,
            nome: usuarios[pedido.ID_USUARIO] || "Cliente não identificado",
            status: pedido.STATUS,
            frete: pedido.FRETE,
            troco: pedido.TROCO,
            subtotal: pedido.SUBTOTAL,
            total: pedido.TOTAL,
            entrega: pedido.ENTREGA,
            pagamento: pedido.PAGAMENTO,
            data: formatarData(pedido.DATA),
            enderecoCompleto: enderecoCompleto || "Endereço não informado",
          };
        });

        setData(pedidosFormatados);
        setFilteredData(pedidosFormatados);

        for (const pedido of pedidos) {
          try {
            const responseItens = await fetch(
              `${Api_VariavelGlobal}/api/pedidos/${pedido.ID_USUARIO}/itens/${pedido.ID_PEDIDO}`
            );
            const itens = await responseItens.json();

            const produtosCompletos = await Promise.all(
              itens.map(async (item) => {
                try {
                  const resProduto = await fetch(
                    `${Api_VariavelGlobal}/api/produtos/${item.ID_PRODUTO}`
                  );
                  const produto = await resProduto.json();
                  return {
                    ID_PRODUTO: item.ID_PRODUTO,
                    NOME: produto.PRODUTO,
                    QUANTIDADE: item.QUANTIDADE,
                    PRECO_UNITARIO: parseFloat(item.PRECO_UNITARIO),
                    SUBTOTAL: item.QUANTIDADE * parseFloat(item.PRECO_UNITARIO),
                  };
                } catch (err) {
                  console.error(`Erro ao buscar produto ${item.ID_PRODUTO}`, err);
                  return null;
                }
              })
            );

            setProdutosPorPedido((prev) => ({
              ...prev,
              [pedido.ID_PEDIDO]: produtosCompletos.filter(Boolean),
            }));
          } catch (error) {
            console.error(`Erro ao buscar itens do pedido ${pedido.ID_PEDIDO}`, error);
          }
        }
      } catch (error) {
        console.error("Erro ao buscar os pedidos:", error);
      }
    };
    fetchPedidos();
  }, [usuarios]);

  // Busca
  const handleSearch = (value) => {
    setSearchValue(value);
    const filtered = data.filter(
      (pedido) =>
        pedido.pedido.toString().includes(value) ||
        (pedido.ID_USUARIO && pedido.ID_USUARIO.toString().includes(value)) ||
        (pedido.nome && pedido.nome.toLowerCase().includes(value.toLowerCase()))
    );
    setFilteredData(filtered);
    setOptions(
      filtered.map((pedido) => ({
        value: pedido.pedido.toString(),
        label: `Pedido ${pedido.pedido} - Cliente ${pedido.nome || "N/A"}`,
      }))
    );
  };

  const onSelect = (value) => {
    setSearchValue(value);
    const filtered = data.filter((pedido) => pedido.pedido.toString() === value);
    setFilteredData(filtered);
  };

  const traduzirPagamento = (valor) => {
    switch (parseInt(valor, 10)) {
      case 1:
        return "Dinheiro";
      case 2:
        return "Cartão";
      case 3:
        return "Pix";
      case 4:
        return "Ifood";
      case 5:
        return "Online";
      default:
        return "Desconhecido";
    }
  };

  const handleExpand = (expanded, record) => {
    setExpandedRowKeys(expanded ? [record.key] : []);
  };

  const columns = [
    { title: "Pedido", dataIndex: "pedido", key: "pedido" },
    { title: "Cliente", dataIndex: "nome", key: "nome" },
    {
      title: "Pagamento",
      dataIndex: "pagamento",
      key: "pagamento",
      render: (text) => traduzirPagamento(text),
    },
    {
      title: "Total",
      dataIndex: "total",
      key: "total",
      render: (text) => `R$ ${parseFloat(text).toFixed(2)}`,
    },
    { title: "Entrega", dataIndex: "entrega", key: "entrega" },
    { title: "Data do Pedido", dataIndex: "data", key: "data" },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        const { texto, cor } = traduzirStatus(status);
        return <Tag color={cor}>{texto}</Tag>;
      },
    },
  ];

  return (
    <>
      <AutoComplete
        popupMatchSelectWidth={252}
        style={{ width: 300, marginBottom: 10 }}
        value={searchValue}
        options={options}
        onSelect={onSelect}
        onSearch={handleSearch}
        size="large"
      >
        <Input.Search
          size="large"
          placeholder="Buscar por Pedido ou Usuário"
          enterButton
        />
      </AutoComplete>

      {/* Overlay - fecha ao clicar fora */}
      {expandedRowKeys.length > 0 && (
        <div
          className="overlay-foco"
          onClick={() => setExpandedRowKeys([])}
        />
      )}

      <Table
        columns={columns}
        dataSource={filteredData}
        size="small"
        rowKey="key"
        rowClassName={(record) =>
          expandedRowKeys.includes(record.key)
            ? "linha-selecionada"
            : record.status === 7
            ? "linha-cancelada"
            : "linha-expandivel"
        }
        expandable={{
         expandedRowRender: (record) => {
  const produtos = produtosPorPedido[record.pedido] || [];

  // Calcular totais
  const totalSubtotal = produtos.reduce(
    (acc, item) => acc + (Number(item.SUBTOTAL) || 0),
    0
  );
  const frete = Number(record.frete || 0);
  const totalGeral = totalSubtotal + frete;

  // Linhas de resumo
  const resumo = [
    {
      key: "subtotal",
      NOME: <strong>Subtotal</strong>,
      QUANTIDADE: "",
      PRECO_UNITARIO: "",
      SUBTOTAL: `R$ ${totalSubtotal.toFixed(2)}`,
    },
    {
      key: "frete",
      NOME: <strong>Frete</strong>,
      QUANTIDADE: "",
      PRECO_UNITARIO: "",
      SUBTOTAL: `R$ ${frete.toFixed(2)}`,
    },
    {
      key: "total",
      NOME: <strong>Total</strong>,
      QUANTIDADE: "",
      PRECO_UNITARIO: "",
      SUBTOTAL: <strong>R$ {totalGeral.toFixed(2)}</strong>,
    },
  ];

    // Função de cancelar forçado
    const cancelarPedidoForcado = async (id) => {
      try {
        const response = await fetch(
          `${Api_VariavelGlobal}/api/pedidos/cancelar-forcado/${id}`,
          { method: "POST" }
        );
        if (!response.ok) throw new Error("Erro ao cancelar");
    
        message.success(`Pedido ${id} cancelado com sucesso!`);
    
        // Atualizar status no frontend
        setData((prevData) =>
          prevData.map((pedido) =>
            pedido.pedido === id ? { ...pedido, status: 7 } : pedido
          )
        );
        setFilteredData((prevData) =>
          prevData.map((pedido) =>
            pedido.pedido === id ? { ...pedido, status: 7 } : pedido
          )
        );
      } catch (err) {
        console.error(err);
        message.error("Falha ao cancelar o pedido.");
      }
    };

  return (
    <div className="area-expandida" onClick={(e) => e.stopPropagation()}>
      <p><strong>Endereço:</strong> {record.enderecoCompleto}</p>
      <p><strong>Telefone:</strong> {record.telefone}</p>

      {/* Botão cancelar forçado */}
      {record.status !== 7 && (
        <Popconfirm
          title="Tem certeza que deseja cancelar este pedido?"
          okText="Sim"
          cancelText="Não"
          onConfirm={() => cancelarPedidoForcado(record.pedido)}
        >
          <Button danger type="primary" style={{ marginBottom: 10 }}>
            Cancelar Pedido
          </Button>
        </Popconfirm>
      )}

      <Table
        className="tabela-produtos-expandida"
        columns={[
          { title: "Produto(s)", dataIndex: "NOME", key: "NOME" },
          { title: "Qtd", dataIndex: "QUANTIDADE", key: "QUANTIDADE" },
          {
            title: "Preço Unitário",
            dataIndex: "PRECO_UNITARIO",
            key: "PRECO_UNITARIO",
            render: (text) => (text ? `R$ ${Number(text).toFixed(2)}` : ""),
          },
          {
            title: "Subtotal",
            dataIndex: "SUBTOTAL",
            key: "SUBTOTAL",
            render: (text) =>
              typeof text === "number" ? `R$ ${text.toFixed(2)}` : text,
          },
        ]}
        dataSource={[...produtos, ...resumo]}
        rowKey={(row) => row.key || row.ID_PRODUTO}
        pagination={false}
        size="small"
      />
    </div>
  );
},
          expandRowByClick: true,
          expandedRowKeys: expandedRowKeys,
          onExpand: handleExpand,
        }}
      />

      <style>{`
        .linha-expandivel {
          cursor: pointer;
        }
        .linha-selecionada {
          background-color: #e6f7ff !important;
          cursor: pointer;
        }
        .linha-cancelada {
          background-color: #fff1f0 !important;
          text-decoration: line-through;
          cursor: pointer;
        }
        .tabela-produtos-expandida .ant-table-tbody > tr > td {
          background-color: #f6ffed !important;
        }
        .tabela-produtos-expandida .ant-table-thead > tr > th {
          background-color: #d9f7be !important;
        }

        /* Overlay escuro */
        .overlay-foco {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background: rgba(0, 0, 0, 0.6);
          z-index: 10;
        }

        /* rea expandida em destaque */
        .ant-table-expanded-row > td {
          padding: 0 !important;
        }
        .area-expandida {
          position: relative;
          z-index: 11;
          background: #fff;
          padding: 16px;
          border-radius: 12px;
          box-shadow: 0 6px 16px rgba(0,0,0,0.25);
        }
      `}</style>
    </>
  );
};

export default PedidosTodos;
